import { compose, mdsWidget } from 'dojo/_base/declare';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import template from './MaintenanceInfo.html?raw';

class MaintenanceInfo extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    inventarEntity: any = null;
    _selectedMaintenanceBundle: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }


    _setEntityAttr(entity: any): void {

        domClass.add(this.sectionMaintenanceBundles, "w3-hide");
        domClass.add(this.sectionInventoryNote, "w3-hide");

        this.inventarEntity = entity;

        this.txtInventoryTitle.innerHTML = this.inventarEntity.tmp_label;

        this.inputMaintenanceBundle.entities = this.inventarEntity.EL_maintenance_bundle_inventory;
        this.inputMaintenanceBundle._constructOptions();

        if (this.inventarEntity.Note != null && this.inventarEntity.Note != "") {
            this.txtInventoryNote.innerHTML = this.inventarEntity.Note;
            domClass.remove(this.sectionInventoryNote, "w3-hide");
        }

        if (this.inventarEntity.EL_maintenance_bundle_inventory.length > 0) {

            this.inputMaintenanceBundle.set("value", this.inventarEntity.EL_maintenance_bundle_inventory[0]);

            if (this.inventarEntity.EL_maintenance_bundle_inventory.length > 1) {
                domClass.remove(this.sectionMaintenanceBundles, "w3-hide");
            }

            domClass.remove(this.sectionMaintenanceInstructions, "w3-hide");
        }

        if (this.inventarEntity.EL_property_device_installation_assignment_device_installation) {
            domClass.remove(this.sectionInventoryProperties, "w3-hide");
            domAttr.set(this.inventoryPropertiesHeading, "innerHTML", this.translations["MaintenanceInfo_InventoryProps_Heading"].format(this.inventarEntity.tmp_label))

            domConstruct.empty(this.inventoryPropertiesContainer);

            for (var i = 0; i < this.inventarEntity.EL_property_device_installation_assignment_device_installation.length; i++) {
                var invProp = this.inventarEntity.EL_property_device_installation_assignment_device_installation[i];
                var row = domConstruct.create("div", {
                    "className": "inventoryPropRow w3-block"
                }, this.inventoryPropertiesContainer);

                var prop = domConstruct.create("label", {
                    "className": "label",
                    "innerHTML": invProp.ref_vt_property.Name
                }, row);

                var value = domConstruct.create("div", {
                    "className": "value",
                    "innerHTML": invProp.value_text_global
                }, row);
            }

        }

    }

    _setBundleAttr(entity: any): void {
        //console.debug("_setBundleAttr", entity);
        this._selectedMaintenanceBundle = entity;

        this.drawMaintenanceSteps();
    }

    drawMaintenanceSteps(): void {

        domConstruct.empty(this.infoContainer);

        let list = domConstruct.create("ul", {}, this.infoContainer);

        for (let i = 0; i < this._selectedMaintenanceBundle.EL_maintenance_occupation_maintenance_bundle.length; i++) {
            let step = this._selectedMaintenanceBundle.EL_maintenance_occupation_maintenance_bundle[i];

            domConstruct.create("li", { innerHTML: step.description }, list);
        }
    }

    _onChangeMaintenaceBundle(value: any): void {
        //console.debug("_onChangeMaintenaceBundle", value, this.inventarEntity);

        this.set("bundle", value);


    }

}
MaintenanceInfo.prototype.declaredClass = 'WidgetCollection.Maintenance.MaintenanceInfo';

export default mdsWidget(MaintenanceInfo);
